import Vue from 'vue'

import withRender from './summary-dim-rating.html'
import './summary-dim.scss'
import './summary-dim-rating.scss'

export default withRender(Vue.extend({
  props: {
    averageRating: {
      type: Number,
      default: 0.0
    },
    headingLevel: { type: Number, default: 3 }
  },
  computed: {
    ratingPercentage() {
      return `${(this.averageRating / 5.0 * 100).toFixed(1)}%`
    }
  }
}))
